import { h, Component } from 'preact';
import { createPortal } from 'preact/compat';
import { cx } from 'react-emotion';
import { withContext } from 'common/context';
import { getButtonProps } from '../../common/props';
import Button from '../Button/Button';
import PopupFocusLock from './PopupFocusLock';
import CarouselViewer from '../CarouselViewer/CarouselViewer';
import { styles } from './styles';

class Popup extends Component {
  popupTransformation = {
    crop: 'limit'
  };

  componentDidMount() {
    this.bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = this.bodyOverflow;
  }

  close = e => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  };

  render(props) {
    const { config } = props.context;
    const classes = styles(props);

    return createPortal(
      <div
        role="dialog"
        data-test="popup"
        className={classes.popup}
        onKeyDown={props.keyDownHandler}
      >
        <PopupFocusLock>
          <Button
            {...getButtonProps(props)}
            icon="close"
            className={classes.close}
            onClick={this.close}
          />
          <div className={cx(classes.zoomWrap)}>
            <CarouselViewer
              index={props.index}
              items={config.selectMediaAssets()}
              width={window.innerWidth}
              height={window.innerHeight}
              transformation={this.popupTransformation}
              prevItem={props.prevItem}
              nextItem={props.nextItem}
              onItemSwipe={props.onItemSwipe}
              setZoom={props.setZoom}
              inPopup={true}
            />
          </div>
        </PopupFocusLock>
      </div>,
      document.body
    );
  }
}

export default withContext(Popup);
